import { render, staticRenderFns } from "./IntegrationFormWebhook.vue?vue&type=template&id=720e4d20&scoped=true"
import script from "./IntegrationFormWebhook.vue?vue&type=script&lang=js"
export * from "./IntegrationFormWebhook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720e4d20",
  null
  
)

export default component.exports